<template>
    <CHeader position="sticky" class="mb-4" >
        <CContainer fluid>
            <CHeaderToggler @click="$store.commit('toggleSidebar')">
                <FontAwesomeIcon icon="bars"/>
            </CHeaderToggler>
            <CHeaderBrand class="mx-auto d-lg-none" to="/">
                <!--                    <CIcon :icon="logo" height="48" alt="Logo" />-->
                <img src="/images/logo.png" alt="VACC CZ Logo" height="48"/>

            </CHeaderBrand>
<!--            <CHeaderNav class="d-none d-md-flex me-auto">-->
<!--                <CNavItem>-->
<!--                    <Link class="nav-link" href="/dashboard"> Dashboard </Link>-->

<!--                </CNavItem>-->
<!--                <CNavItem>-->
<!--                    <Link href="#" class="nav-link">Users</Link>-->
<!--                </CNavItem>-->
<!--                <CNavItem>-->
<!--                    <Link href="#" class="nav-link">Settings</Link>-->
<!--                </CNavItem>-->
<!--            </CHeaderNav>-->
            <CHeaderNav>
                <CNavItem>
                    <CButtonGroup size="sm" role="group" class="position-relative" style="top:3px;">
                        <CButton color="primary" variant="ghost" @click="$store.commit('toggleDarkMode')" :active="!$store.state.darkMode"><FontAwesomeIcon icon="sun"/></CButton>
                        <CButton color="primary" variant="ghost" @click="$store.commit('toggleDarkMode')" :active="$store.state.darkMode"><FontAwesomeIcon icon="moon"/></CButton>
                    </CButtonGroup>
                </CNavItem>
                <CDropdown variant="nav-item">
                    <CDropdownToggle>{{ $page.props.auth.user.name }}</CDropdownToggle>
                    <CDropdownMenu>
                        <Link class="dropdown-item" href="/profile" as="button">{{$t('header.settings')}}</Link>
                        <Link class="dropdown-item" href="/logout" method="post" as="button">{{ $t('header.logout')}}</Link>
                    </CDropdownMenu>
                </CDropdown>
                <CDropdown variant="nav-item">
                    <CDropdownToggle :caret="false"><FontAwesomeIcon icon="bell" /></CDropdownToggle>
                    <CDropdownMenu>
                        <div class="small text-muted p-3">Žádná upozornění</div>
                    </CDropdownMenu>
                </CDropdown>



            </CHeaderNav>
        </CContainer>
    </CHeader>
</template>

<script>
import { CButtonGroup, CHeader, CContainer, CHeaderToggler, CHeaderBrand, CHeaderNav, CNavItem, CDropdown, CDropdownToggle ,CDropdownItem, CDropdownMenu, CButton} from "@coreui/vue";
import {CDatePicker} from "@coreui/vue-pro";



export default {
    name: "AppHeader",
    components: {
        CButtonGroup,
        CDatePicker,
        CButton,
        CDropdown, CDropdownToggle,CDropdownItem,CDropdownMenu,
        CHeader, CContainer, CHeaderToggler, CHeaderBrand, CHeaderNav, CNavItem,
    }

}
</script>
<script setup>
import {computed, onMounted, watch} from "vue";
import store from "../Store";


const darkMode = computed(() => store.state.darkMode)
watch(darkMode, (newVal) => {
    newVal ? document.body.classList.add('dark-theme') : document.body.classList.remove('dark-theme')
})

onMounted(() => {store.state.darkMode ? document.body.classList.add('dark-theme') : null })

</script>

<style scoped>

</style>
